"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.records.title': 'Sus Registros de Incorporación',
    'onboarding.records.empty.title': 'Aún No Hay Registros de Incorporación',
    'onboarding.records.empty.description': 'Inicie su primer proceso de incorporación para ver registros aquí.',
};
